'use client';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { isLoggedIn } from '../../../../../utils/auth';
// import {
//   isStepComplete, 
//   isStepValid, 
// } from '../../../../../utils/checkout';

import CheckoutStepBuylistAuthInput from './CheckoutStepBuylistAuthInput';

let allActionCreators = Object.assign({});

export class CheckoutStepBuylistAuth extends Component {

  componentDidMount() {
    if(isLoggedIn()) {
      this.props.setStepData(this.props.config, { 
        isGuest: false, 
      });
    }
  }

  getStepComponent() {

    const { 
      isStepComplete, 
      isStepValid, 
    } = require('../../../../../utils/checkout');

    // const { CheckoutStepBuylistAuthInput } = require('./CheckoutStepBuylistAuthInput').default;

    if(isStepValid(this.props.config, this.props.checkout.stepData) && isStepComplete(this.props.config, this.props.checkout.stepData)) {
      return null;
    }
    return <CheckoutStepBuylistAuthInput 
            config={this.props.config}
            isBuylist={this.props.isBuylist}
            setStepData={this.props.setStepData} />
  }

  render() {
    return <div className={'CheckoutStepBuylistAuth CheckoutStepComponent'}>{this.getStepComponent()}</div>;
  }
}

function mapStateToProps(state) {
  return {
    checkout: state.checkout,
  };
}

export default connect(mapStateToProps, allActionCreators)(withTranslation()(CheckoutStepBuylistAuth));